import { render, staticRenderFns } from "./ShareCart.vue?vue&type=template&id=60f0d8e8"
import script from "./ShareCart.vue?vue&type=script&lang=js"
export * from "./ShareCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports